import React from 'react'

function personaltax() {
  return (
    <div>personaltax</div>
  )
}

export default personaltax